var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"13","height":"13","rx":"7.5","fill":"#FD7E14"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.22109 4.645V3.43H5.78109V4.645H6.22109ZM7.18509 10V5.176H5.81709V10H6.18509Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }